module.exports = {"350206001":"湖里街道","350206002":"殿前街道","350206003":"禾山街道","350206004":"江头街道","350206005":"金山街道","350206405":"火炬高技术开发区","350206406":"象屿保税区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350206.json
// module id = 1080
// module chunks = 0